import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";

export default function PolicyLayout({ title, subtitle, updated, children, testid }) {
  return (
    <div className="min-h-screen flex flex-col bg-[hsl(var(--background))]" data-testid={testid}>
      <PublicHeader />
      <main className="flex-1 w-full max-w-3xl mx-auto px-5 md:px-6 py-12 md:py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-[hsl(var(--muted))] hover:text-[hsl(var(--foreground))] transition-colors mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft size={15} weight="bold" /> Back to home
        </Link>
        <div className="overline mb-2">AIR12</div>
        <h1 className="text-3xl sm:text-4xl heading tracking-tight">{title}</h1>
        {subtitle && <p className="text-base text-[hsl(var(--muted))] mt-3 leading-relaxed">{subtitle}</p>}
        {updated && <p className="overline mt-4">Last updated · {updated}</p>}
        <div className="mt-10 policy-body space-y-6 text-[15px] leading-relaxed text-[hsl(var(--foreground))]">
          {children}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section className="space-y-2.5">
      {heading && <h2 className="text-lg heading tracking-tight">{heading}</h2>}
      <div className="space-y-2.5 text-[15px] leading-relaxed text-[hsl(var(--muted))]">{children}</div>
    </section>
  );
}
